import React, { useEffect, useMemo, useState } from "react";
import GroupAdminHeader from "../../../Comman/Header";
import GroupAdminSidebar from "../../../Comman/Sidebar";
import GroupAdminUperSide from "../../../Comman/UperSide";
import { useHistory, Link } from "react-router-dom";
import api from "../../../../CommonApi/axios";
import MaterialTable from "material-table";
import { ActionIcon, useStyles } from "../../../Comman/TableuseStyles";
import { Tableoptions } from "../../../Comman/TableOption";
import headers from "../../../../CommonApi/headers";
import $ from "jquery";
import { useMediaQuery } from "react-responsive";
import { Button, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import RedeemIcon from '@mui/icons-material/Redeem';
import { ToastContainer, toast } from "react-toastify";
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import CommonVoucher from "./CommonVoucher";
import { getBranchList, getVoucherPurchasedList } from "../../../../Store";
import { connect } from "react-redux"
import useDrawer from "../../../../context/DrawerContext";
import DownloadIcon from '@mui/icons-material/Download';
import useError from "../../../Comman/Error/useError";
import { ErrorMessage } from "../../../Comman/Error/ErrorMessage";
import { getCurrencyLabel } from "../../../Comman/currencyUtils/currencyUtils";
import { showSuccessNotification } from "../../../Comman/Swal/Swal";
import useWindowHeight from "../../../NewTableCommon/useWindowsPosition";
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { tableOptionCouponAndVoucher } from "../../../NewTableCommon/tableOption";
import TableFilter from "../../../NewTableCommon/tableFilter";
import ColumPopoverCommon from "../../../NewTableCommon/ColumPopoverCommon";
import Select from "react-select";
import { selectStyles } from "../../../Comman/CommonFunction/CommonFunction";
import { branchfilterAndMapData, getPlaceholder, getSelectOptions } from "../../../Comman/BranchList";
import { userPermissionType, VouchersPermissions } from "../../../Comman/UserPermission";
import { HeaderStyle } from "../../Component/OrderManagement/TableCommonModule";

window.jquery = window.$ = $;

function GroupAdminPurchesListVoucher({ getVoucherPurchasedList, voucherPurchasedList, getBranchList, BranchList_ }) {
  const isMobile = useMediaQuery({ query: `(max-width: 760px)` });
  let history = useHistory();
  const userPermissionType_ = userPermissionType === "groupadmin"

  useEffect(() => {
    getVoucherPurchasedList();
    getBranchList();
  }, []);

  const [reedem_amount, setreedem_amount] = useState("");
  const [_ID, set_ID] = useState("");
  const [VoucherCode, setVoucherCode] = useState("");
  const [Currency, setCurrency] = useState("")

  const { error, showError, clearError } = useError();


  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);



  function handleSubmit(event) {
    event.preventDefault();
    showError(null);


    if (reedem_amount == "") {
      showError(`Please enter amount`);
      return;
    }
    else if (reedem_amount == 0) {
      showError(`Amount should be greater than zero`);
      return;
    } else {

      let item = {
        reedem_amount: reedem_amount,
      }
      // console.log("item" ,item);
      api
        .post(`/groupAdmin/purchase_voucher/redeem/${_ID}`, item, { headers })
        .then((res) => {
          showSuccessNotification("Saved successfully.")
          window.location.reload(true);
        })
        .catch((err) => {
          if (err.response) {
            showError(err.response?.data?.error?.message);
          }
        });
    }
  }


  function handleSendEmail(_ID, currency) {
    // showError(null);
    handleMenuClose();
    // console.log("_ID" ,_ID);
    api
      .get(`/groupAdmin/purchase_voucher/send-voucher-email/${_ID}/${currency}`, { headers })
      .then((res) => {
        handleMenuClose();
        showSuccessNotification("Email sent successfully.")
        // window.location.reload(true);
      })
      .catch((err) => {
        if (err.response) {
          handleMenuClose();
          // showError(err.response?.data?.error?.message);
          toast?.error(err.response?.data?.error?.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      });
  }

  const handleMenuOpen = (event, rowData) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(rowData);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };


  const { drawerPos, handleDrawer, mainClassCustome } = useDrawer();

  const filteredOptions = branchfilterAndMapData(BranchList_);
  const windowHeight = useWindowHeight();
  const pathname = window.location.pathname;
  const pathnamesplits = pathname.split("/");
  const url = pathnamesplits[4];

  const columnsDataString = sessionStorage.getItem(`${url}_columnData`);
  const columnsData = columnsDataString ? JSON.parse(columnsDataString) : null;
  const DisplayCol = columnsData && Object.values(columnsData).includes(false);
  const filterData = JSON.parse(sessionStorage.getItem(`${url}_filterData`));
  const branchName = JSON.parse(sessionStorage.getItem(`${url}_branchName`));

  const [updateColumns, setUpdateColumns] = useState(false);
  const ColumnsDataString = sessionStorage.getItem(`${url}_columnData`);
  const dineInColumnsData = ColumnsDataString ? JSON.parse(ColumnsDataString) : null;

  const [BranchId, setBranchID] = useState(branchName || "");

  const [FilterData, SetFilterData] = useState("");
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [isFilterPopoverOpen, setIsFilterPopoverOpen] = useState(false);

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
    setIsFilterPopoverOpen(true);
  };

  const handleFilterClose = () => {
    setIsFilterPopoverOpen(false);
  };

  const handleApplyFilters = (filterData) => {
    setIsFilterPopoverOpen(false);
    SetFilterData(filterData)
  };

  const [anchorEl_, setAnchorEl_] = useState(null);

  const handleClickColum_ = (event) => {
    setAnchorEl_(event.currentTarget);
  };
  const handleCloseColum_ = () => {
    setAnchorEl_(null);
  };

  const onColumnDataChange = () => {
    setUpdateColumns(prevState => !prevState);
  };

  const filteredMenuList = useMemo(() => {
    if (BranchId && BranchId.value !== "All") {
      return voucherPurchasedList.filter(menu => menu.branch?._id === BranchId.value);
    }
    return voucherPurchasedList;
  }, [voucherPurchasedList, BranchId]);

  // console.log("filteredMenuList", filteredMenuList);

  const columns = [
    {
      title: "Voucher Code",
      field: "voucher_code",
      render: (rowData) => {
        return (
          <div style={{ color: "blue", cursor: "pointer" }}
            onClick={() =>
              history.push(`/group_admin/coupon_voucher_management/voucher_management/purchase_voucher_details/${rowData._id}/${rowData?.branch?.currency}`)}>
            {rowData?.voucher_code}
          </div>
        );
      },
    },
    {
      title: "Customer",
      render: (rowData) => {
        return (
          <>
            <div>
              {rowData?.client_name}
            </div>
            <div>
              {rowData?.client_mobile_number}
            </div>
            <div>
              {rowData?.client_email}
            </div>
          </>
        );
      },
      customSort: (a, b) => a.client_name.localeCompare(b.client_name),
    },
    {
      title: "Branch",
      render: (rowData) => {
        return (rowData?.branch?.branch_name_EN);
      },
      customSort: (a, b) => a?.branch?.branch_name_EN.localeCompare(b?.branch?.branch_name_EN),
    },

    {
      title: 'Voucher Amount',
      field: 'voucher_amount',
      render: (rowData) => `${getCurrencyLabel(rowData?.branch?.currency)} ${Number(rowData.voucher_amount || 0).toFixed(2)}`,
      customSort: (a, b) => {
        const voucherAmountA = Number(a.voucher_amount || 0);
        const voucherAmountB = Number(b.voucher_amount || 0);
        return voucherAmountA - voucherAmountB; // Ascending order
      },
    },



    // {
    //   title: "Voucher Discounted CHF",
    //   field: "discounted_amount",
    //   render: (rowData) => {
    //     return (
    //       <div>{Number(rowData.discounted_amount || rowData.voucher_amount)}</div>
    //     );
    //   },
    // },
    {
      title: `Remaining Amount`,
      field: "remaining_amount",
      render: (rowData) => { return `${getCurrencyLabel(rowData?.branch?.currency)} ${(Number(rowData.remaining_amount || 0).toFixed(2))}` },
      // customSort: (a, b) => {
      //   const remainingAmountA = Number(a.remaining_amount || 0);
      //   const remainingAmountB = Number(b.remaining_amount || 0);
      //   return remainingAmountA - remainingAmountB;
      // },
    },
    // {
    //   title: "Voucher Status",
    //   render: (rowData) => {
    //     return <>{rowData?.voucher_status ? rowData?.voucher_status === "purchased_pending" 
    //     ? "Purchased Pending" : rowData?.voucher_status === "purchased" 
    //     ? "Purchased" : rowData?.voucher_status === "reedem" 
    //     ? "Reedem"  : "" : "----"}</>;
    //   },
    // },

    // {
    //   title: "Start date",
    //   render: (rowData) => {
    //     return <>{moment( rowData?.start_date).format("DD/MM/YYYY")}</>;
    //   },
    // },
    // {
    //   title: `End date`,
    //   render: (rowData) => {
    //     return <>{moment(rowData?.end_date).format("DD/MM/YYYY")}</>;
    //   },
    // },

    //  {
    //   title: "Download",
    //   render: (rowData) => {
    //     return (
    //       <div>{Number(rowData.discounted_amount || rowData.voucher_amount)}</div>
    //     );
    //   },
    // },

    {
      title: "Redeem",
      render: (rowData) => {
        return (
          <Link
            to={rowData?.remaining_amount > 0 ? "#kt_modal_1" : ""}
            type="button"
            data-bs-toggle="modal"
            className={isMobile ? "mx-2" : "mx-3"}
            onClick={() => {
              showError(null);
              setreedem_amount("")
              set_ID(rowData?._id);
              setVoucherCode(rowData?.voucher_code)
              setCurrency(rowData?.branch?.currency)
            }}
          >
            <Button
              style={{
                textTransform: "capitalize",
                border: rowData?.remaining_amount === 0 ? "1px solid #9E9E9E" : "1px solid #F25042",
                color: rowData?.remaining_amount === 0 ? "#9E9E9E" : "#F25042"
              }}
              variant="outlined"
              startIcon={<RedeemIcon />}
            >
              Redeem
            </Button>
          </Link>
        );
      },
      sorting: false,
    },

    // {
    //   title: "Emailing",
    //   render: (rowData) => {
    //     return (
    //       <Button style={{ textTransform: "capitalize", width: "max-content", border: "1px solid #F25042", color: "#F25042" }} variant="outlined"
    //         onClick={() => {
    //           handleSendEmail(rowData?._id);
    //         }}>
    //         Send Email </Button>
    //     )
    //   },
    //   sorting: false,
    // },
  ];

  const EDIT = VouchersPermissions?.access?.includes("edit");
  const DELETE = VouchersPermissions?.access?.includes("delete");
  const VIEW = VouchersPermissions?.access?.includes("view");


  const Columns = useMemo(() => {
    const columns = [
      {
        accessorKey: 'voucher_code',
        header: 'Voucher Code',
        size: 300,
        Cell: ({ row }) => {
          const hasViewPermission = userPermissionType_ || VIEW;
          return hasViewPermission ? (
            <Link
              to={{
                pathname: `/group_admin/coupon_voucher_management/voucher_management/purchase_voucher_details/${row?.original?._id}/${row?.original?.branch?.currency}`,
                // state: { menuId: row?.original?._id, branchID: row?.original?.branch?._id },
              }}
            >
              <span style={HeaderStyle?.uniqueCodeHeader}>
                {row?.original?.voucher_code}
              </span>
            </Link>
          ) : (
            <span style={HeaderStyle?.uniqueCodeHeader}>
              {row?.original?.voucher_code}
            </span>
          );
        },
      },
      {
        accessorKey: 'client_name',
        header: 'Customer Details',
        // size: 270,
        Cell: ({ row }) => (<>
          <div>
            {row?.original?.client_name}
          </div>
          <div>
            {row?.original?.client_mobile_number}
          </div>
          <div>
            {row?.original?.client_email}
          </div>
        </>),
      },
      {
        accessorKey: 'branch?.branch_name_EN',
        header: 'Branch Name',
        // size: 270,
        Cell: ({ row }) => (row?.original?.branch?.branch_name_EN || "---"),
      },
      {
        accessorKey: 'voucher_category',
        header: 'Voucher Amount',
        size: 270,
        Cell: ({ row }) => (`${getCurrencyLabel(row?.original?.branch?.currency)} ${Number(row?.original?.voucher_amount || 0).toFixed(2)}`),
      },
      {
        accessorKey: 'remaining_amount',
        header: 'Remaining Amount',
        // size: 270,
        Cell: ({ row }) => (`${getCurrencyLabel(row?.original?.branch?.currency)} ${(Number(row?.original?.remaining_amount || 0).toFixed(2))}`)
      },
      {
        accessorKey: 'voucher_validity',
        header: 'Redeem',
        size: 150,
        Cell: ({ row }) => (<Link
          to={row?.original?.remaining_amount > 0 ? "#kt_modal_1" : ""}
          type="button"
          data-bs-toggle="modal"
          className={isMobile ? "mx-2" : "mx-3"}
          onClick={() => {
            showError(null);
            setreedem_amount("")
            set_ID(row?.original?._id);
            setVoucherCode(row?.original?.voucher_code)
            setCurrency(row?.original?.branch?.currency)
          }}
        >
          <Button
            style={{
              textTransform: "capitalize",
              border: row?.original?.remaining_amount === 0 ? "1px solid #9E9E9E" : "1px solid #F25042",
              color: row?.original?.remaining_amount === 0 ? "#9E9E9E" : "#F25042"
            }}
            variant="outlined"
            startIcon={<RedeemIcon />}
          >
            Redeem
          </Button>
        </Link>),
      },
    ];
    return dineInColumnsData === null ? columns : columns?.filter(column => dineInColumnsData[column?.header] === true);
  }, [updateColumns]);


  // console.log("url" ,url)

  const table = useMaterialReactTable({
    columns: Columns,
    data: filteredMenuList,
    ...tableOptionCouponAndVoucher({
      getVoucherPurchasedList,
      url,
      handleClickColum_,
      // handleSubmitActive,
      handleFilterClick,
      windowHeight,
      filterData,
      DisplayCol,
      DELETE,
      // VIEW,
      EDIT,
      history,
      handleSendEmail
    }),
  });


  return (
    <React.Fragment>
      <div
        id="kt_body"
        className="header-fixed header-tablet-and-mobile-fixed toolbar-enabled toolbar-fixed aside-enabled aside-fixed"
      >
        <div className="d-flex flex-column flex-root">
          <div className="page d-flex flex-row flex-column-fluid">
            <GroupAdminSidebar drawerPos={drawerPos} handleDrawer={handleDrawer} />
            <div
              className="wrapper d-flex flex-column flex-row-fluid"
              id="kt_wrapper"
            >
              <GroupAdminHeader />
              <div
                className=" d-flex flex-column flex-column-fluid p-0"
                id="kt_content"
              >
                <div id="kt_content_container" className="mx-7">
                  <main style={{ position: "initial", marginTop: "-27px" }} className={mainClassCustome.join(" ")}>
                    <div className="row ">
                      <div className="col-md-6">
                        <div
                          className="d-flex justify-content-start"
                          data-kt-docs-table-toolbar="base"
                        >
                          <h1 style={{ marginTop: "9px" }} className="anchor fw-bolder mb-5">
                            Voucher Management - Purchased Vouchers

                          </h1>
                          <div style={{ width: '2px', height: '33px', backgroundColor: '#D0D5DD' }} className="mx-4 mt-2" />

                          <Select
                            className="search-line"
                            value={BranchId}
                            placeholder={getPlaceholder(filteredOptions)}
                            options={getSelectOptions(filteredOptions)}
                            onChange={(opt) => {
                              setBranchID(opt);
                              sessionStorage.setItem(`${url}_branchName`, JSON.stringify(opt));
                            }}
                            styles={selectStyles}
                          />



                        </div>
                      </div>
                      <div className="col-md-6 text-end">
                        <div
                          className="d-flex justify-content-end"
                          data-kt-docs-table-toolbar="base"
                        >
                          <button
                            onClick={() =>
                              history.push(
                                "/group_admin/coupon_voucher_management/voucher_management/voucher_templates"
                              )
                            }
                            className="btn btn-primary"
                          >
                            Go Back
                          </button>
                        </div>
                      </div>
                    </div>
                    <hr style={{ opacity: 0.07, marginTop: 7 }} />

                    {/* <div className={"rounded border p-5"}> */}
                    <CommonVoucher />
                    {/* <div className="tab-content" id="myTabContent">
                        <div
                          className="tab-pane fade show active"
                          id="kt_tab_pane_1"
                          role="tabpanel"
                        >
                          <div className={isMobile ? "" : "card card-docs mb-2"}>
                            <div className={isMobile ? "" : "card-body"}>
                              <div className={classes.root}>
                                <MaterialTable
                                  title=""
                                  data={voucherPurchasedList}
                                  columns={columns}
                                  options={Tableoptions}

                                  actions={[
                                    {
                                      icon: () => <ActionIcon />,
                                      tooltip: 'More',
                                      onClick: (event, rowData) => handleMenuOpen(event, rowData)
                                    }
                                  ]}
                                />
                                <Menu
                                  id="simple-menu"
                                  anchorEl={anchorEl}
                                  className="rounded border border-2"
                                  open={Boolean(anchorEl)}
                                  onClose={handleMenuClose}
                                >
                                  <MenuItem
                                    className="py-2 px-4"
                                    onClick={() => {
                                      handleSendEmail(selectedRow?._id, selectedRow?.branch?.currency);
                                    }}
                                    style={{ display: 'flex', flexDirection: 'row' }}>
                                    <ListItemIcon>
                                      <MailOutlineIcon />
                                    </ListItemIcon>
                                    <ListItemText primary={<span style={{ fontSize: '14px', fontFamily: 'inherit', fontWeight: 500 }}>Send Email</span>} />
                                  </MenuItem>
                                  {selectedRow?.voucher_url &&
                                    <MenuItem
                                      className="py-2 px-4"
                                      onClick={() => {
                                        window.open(`${selectedRow?.voucher_url}`);
                                        handleMenuClose()
                                      }}
                                      style={{ display: 'flex', flexDirection: 'row' }}>
                                      <ListItemIcon>
                                        <DownloadIcon />
                                      </ListItemIcon>
                                      <ListItemText primary={<span style={{ fontSize: '14px', fontFamily: 'inherit', fontWeight: 500 }}>Download </span>} />
                                    </MenuItem>}
                                </Menu>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> */}

                    <div className="mt-5">
                      <MaterialReactTable
                        table={table}
                      />

                      {/* </div> */}
                    </div>
                  </main>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ColumPopoverCommon
          anchorEl_={anchorEl_}
          handleClickColum_={handleClickColum_}
          onColumnDataChange={onColumnDataChange}
          handleCloseColum_={handleCloseColum_}
          url23={url}
        />

        {/* <TableFilter
          open={isFilterPopoverOpen}
          anchorEl={filterAnchorEl}
          handleClose={handleFilterClose}
          handleFilter={handleApplyFilters}
          url23={url}
        /> */}
        <GroupAdminUperSide />
      </div>
      <div className="modal fade" tabIndex={-1} id="kt_modal_1">
        <div className="modal-dialog">
          <div className="modal-content">

            <div className="modal-body">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={26}
                height={26}
                viewBox="0 0 26 26"
                fill="none"
                style={{ height: 45, width: 45 }}
              >
                <path
                  d="M2.59961 6.17461C2.59961 4.20019 4.20019 2.59961 6.17461 2.59961H19.8246C21.799 2.59961 23.3996 4.20019 23.3996 6.17461V13.3339C23.0004 13.0042 22.5647 12.717 22.0996 12.4792V10.3996H11.3188L13.4592 12.54C13.7131 12.7938 13.7131 13.2054 13.4592 13.4592C13.2054 13.7131 12.7938 13.7131 12.54 13.4592L10.3996 11.3188V16.8996H11.9688C11.8503 17.3186 11.769 17.7532 11.7288 18.1996H6.17461C4.20019 18.1996 2.59961 16.599 2.59961 14.6246V6.17461ZM6.17461 3.89961C4.91816 3.89961 3.89961 4.91816 3.89961 6.17461V9.09961H5.54744C5.32622 8.71718 5.19961 8.27318 5.19961 7.79961C5.19961 6.36367 6.36367 5.19961 7.79961 5.19961C8.27318 5.19961 8.71718 5.32622 9.09961 5.54744V3.89961H6.17461ZM10.3996 3.89961V5.54744C10.782 5.32622 11.226 5.19961 11.6996 5.19961C13.1356 5.19961 14.2996 6.36367 14.2996 7.79961C14.2996 8.27318 14.173 8.71718 13.9518 9.09961H22.0996V6.17461C22.0996 4.91816 21.0811 3.89961 19.8246 3.89961H10.3996ZM10.3996 9.09961H11.6996C12.4176 9.09961 12.9996 8.51758 12.9996 7.79961C12.9996 7.08164 12.4176 6.49961 11.6996 6.49961C10.9816 6.49961 10.3996 7.08164 10.3996 7.79961V9.09961ZM7.79961 6.49961C7.08164 6.49961 6.49961 7.08164 6.49961 7.79961C6.49961 8.51758 7.08164 9.09961 7.79961 9.09961H9.09961V7.79961C9.09961 7.08164 8.51758 6.49961 7.79961 6.49961ZM3.89961 10.3996V14.6246C3.89961 15.8811 4.91816 16.8996 6.17461 16.8996H9.09961V11.3188L6.95923 13.4592C6.70539 13.7131 6.29383 13.7131 6.03999 13.4592C5.78615 13.2054 5.78615 12.7938 6.03999 12.54L8.18037 10.3996H3.89961ZM24.6996 18.8496C24.6996 22.0805 22.0805 24.6996 18.8496 24.6996C15.6187 24.6996 12.9996 22.0805 12.9996 18.8496C12.9996 15.6187 15.6187 12.9996 18.8496 12.9996C22.0805 12.9996 24.6996 15.6187 24.6996 18.8496ZM21.9087 19.3097L21.912 19.3065C21.9729 19.2448 22.019 19.174 22.0503 19.0984C22.0816 19.0229 22.0991 18.9402 22.0996 18.8535L22.0996 18.8496L22.0996 18.8457C22.0991 18.759 22.0816 18.6763 22.0503 18.6008C22.0186 18.5241 21.9715 18.4523 21.9092 18.39L19.3092 15.79C19.0554 15.5361 18.6438 15.5361 18.39 15.79C18.1362 16.0438 18.1362 16.4554 18.39 16.7092L19.8804 18.1996H16.2496C15.8906 18.1996 15.5996 18.4906 15.5996 18.8496C15.5996 19.2086 15.8906 19.4996 16.2496 19.4996H19.8804L18.39 20.99C18.1361 21.2438 18.1361 21.6554 18.39 21.9092C18.6438 22.1631 19.0554 22.1631 19.3092 21.9092L21.9087 19.3097Z"
                  fill="#12B76A"
                />
              </svg>


              <div className="row mt-6">
                <h1>Redeem Voucher</h1>
              </div>


              <div className="row mt-2">
                <p style={{ fontSize: 16 }}>Voucher code : {VoucherCode}</p>
                <p style={{ fontSize: 16 }}>Please enter the exact amount that the customer has redeemed through their voucher.
                  Proceed to Enter Redeemed Amount</p>
              </div>
              <form
                onSubmit={handleSubmit}
              >
                <div className="my-5">
                  <label
                    className="form-label"
                  >
                    Redeem Amount
                  </label>
                  <div className="input-group mb-3">
                    <div className="input-group-append">
                      <span className="input-group-text" id="basic-addon2">
                        {Currency}
                      </span>
                    </div>
                    <input
                      type="text"
                      className="filterme form-control"
                      placeholder="Enter Amount"
                      value={reedem_amount}
                      onChange={(e) => setreedem_amount(e.target?.value?.replace(/[^0-9.]/g, ""))}
                      aria-describedby="basic-addon2"
                    />
                  </div>
                </div>
                <div className="col-md-12 text-center">
                  <br />
                  <div className="loader" style={{ display: "none" }}>
                    <img src="/assets/loader.gif" />
                  </div>
                </div>
                <ErrorMessage error={error} />
                <div className="container">
                  <div className="row ">
                    <div className="row col-6">
                      <button
                        type="submit"
                        id="kt_modal_new_address_submit"
                        className="btn btn-primary"
                      >
                        Confirm
                      </button>
                    </div>
                    <div className="row col-6 mx-2">
                      <button
                        type="button"
                        className="btn btn-danger"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <ColumPopoverCommon
        anchorEl_={anchorEl_}
        handleClickColum_={handleClickColum_}
        onColumnDataChange={onColumnDataChange}
        handleCloseColum_={handleCloseColum_}
        url23={url}
      />

      {/* <TableFilter
        open={isFilterPopoverOpen}
        anchorEl={filterAnchorEl}
        handleClose={handleFilterClose}
        handleFilter={handleApplyFilters}
        url23={url}
      /> */}

      <ToastContainer />
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  voucherPurchasedList: state?.voucherPurchasedList,
  BranchList_: state.branchList,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getVoucherPurchasedList: () => dispatch(getVoucherPurchasedList()),
    getBranchList: () => dispatch(getBranchList()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GroupAdminPurchesListVoucher);






